import { LocalStorageKey } from '@ankr.com/auth';

export const getAuthToken = () =>
  localStorage.getItem(LocalStorageKey.Token) ?? undefined;
